Router = App.loadClass 'core::Router'
GrowerApp = require('resources/assets/coffee/Grower/GrowerApp').GrowerApp
PortalApp = require('resources/assets/coffee/Portal/PortalApp').PortalApp
AdminApp = require('resources/assets/coffee/Admin/AdminApp').AdminApp

class exports.MainRouter extends Router
    prefix: 'Main'
    module_name: 'MainRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'core::Angular/SetPasswordService', ['$http']

        @controller 'core::Angular/DefaultController', [
            '$scope'
            '$state'
            '$window'
            '$stateParams'
            'Core.Services.Session'
            'Core.Services.Routing'
        ]
        @controller 'core::Angular/LoginController', [
            '$scope'
            '$transitions'
            '$state'
            '$uibModal'
            '$http'
            '$q'
            '$stateParams'
            'Core.Services.Routing'
            'Core.Services.Session'
        ]
        @controller 'core::Angular/ForgotPasswordController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            '$http'
            '$location'
        ]
        @controller 'core::Angular/SetPasswordController', [
            '$scope'
            '$transitions'
            '$state'
            '$stateParams'
            '$http'
            '$q'
            'Main.Services.SetPasswordService'
            'AuthResponse'
            'Core.Services.Routing'
            'Core.Services.Session'
        ]
        @controller 'core::Angular/EmailUnsubscribeController', [
            '$scope'
            '$http'
        ]


    registerRoutes: ($stateProvider) =>
        $stateProvider
            .state 'default',
                url: '/?b?r'
                views:
                    main:
                        template: '<div></div>'
                        controller: 'Main.Controllers.DefaultController'

            .state 'login',
                url: '/login?pending_email?b?r?reset_email'
                params:
                    registration_token: null
                    external_system_name: null
                    reset_email: null
                views:
                    main:
                        templateUrl: 'backend/login'
                        controller: 'Main.Controllers.LoginController'

            .state 'logout',
                url: '/logout?pending_email?b'
                views:
                    main:
                        template: '<div></div>'
                        controller: [
                            '$state'
                            'Core.Services.Session'
                            '$stateParams'
                            ($state, session, $stateParams) =>
                                session.remove 'Authorization'
                                session.remove 'OriginalUser'
                                session.remove 'AuthTime'
                                session.remove 'SelectedCompany-grower'
                                session.remove 'SelectedCompany-portal'
                                session.remove 'SelectedCompany-admin'

                                Raven?.setUserContext()

                                $state.go 'login', $stateParams
                        ]

            .state 'set-password',
                url: '/set-password?authentication_code&data_token&is_password_reset'
                views:
                    main:
                        templateUrl: 'backend/session-mgmt/set-password-layout'
                        controller: 'Main.Controllers.SetPasswordController'
                resolve:
                    AuthResponse: [ 'Main.Services.SetPasswordService', '$stateParams', (repository, $stateParams) =>
                        return repository.checkAuthCode($stateParams)
                    ],

            .state 'unsubscribe',
                url: '/unsubscribe/:token'
                views:
                    main:
                        controller: 'Main.Controllers.EmailUnsubscribeController'
                        templateUrl: ($stateParams) ->
                            'backend/grower/unsubscribe/from-email/' + $stateParams.token

            .state 'grower',
                url: '/grower'
                views:
                    main:
                        templateUrl: 'backend/grower/home/index'
                        controller: ['$scope', '$state', '$timeout', ($scope, $state, $timeout) ->
                            if window.App? and window.App instanceof GrowerApp
                                console.error "The grower app is being reloaded! This screws with the map. Don't do this! If you are using { reload: true }, change it to { reload: 'grower.my.state' } instead."

                            window.App = new GrowerApp()
                            App.boot()
                            if $state.current.name is 'grower'
                                $timeout () =>
                                    angular.element('#nav_primary_links li:first-child a').first().trigger('click')
                        ]

            .state 'portal',
                url: '/portal'
                views:
                    main:
                        templateUrl: 'backend/portal/home/index'
                        controller: ['$scope', '$state', '$timeout', ($scope, $state, $timeout) ->
                            if window.App? and window.App instanceof PortalApp
                                console.error "The portal app is being reloaded! This screws with the map. Don't do this! If you are using { reload: true }, change it to { reload: 'portal.my.state' } instead."

                            window.App = new PortalApp()
                            App.boot()
                            if $state.current.name is 'portal'
                                $timeout () =>
                                    angular.element('#nav_primary_links > li:first-child a').first().trigger('click')
                        ]

            .state 'admin',
                url: '/admin'
                views:
                    main:
                        templateUrl: 'backend/admin/home/index'
                        controller: ['$scope', '$state', '$timeout', ($scope, $state, $timeout) ->
                            window.App = new AdminApp()
                            App.boot()
                            if $state.current.name is 'admin'
                                $timeout () =>
                                    angular.element('#nav_primary_links li:first-child a').first().trigger('click')
                        ]

            .state 'dashboard',
                url: '/dashboard'
                views:
                    main:
                        templateUrl: 'backend/dashboard-page'
                        controller: 'DashboardController'

            .state 'api-data-forward',
                url: '/forward?token'
                views:
                    main:
                        template: '<div></div>'
                        controller: 'ApiDataForwardingController'
